import { useCompanyForm } from 'pages/organisations/companies/v5/hooks/useCompanyForm';
import { FORM_FIELD_PATHS } from '../../constants';
import WholesalerMultiSelectField from './WholesalerMultiSelectField';

const CarriersMultiSelect = ({ darkMode }) => {
    const { formData } = useCompanyForm();

    return (
        <WholesalerMultiSelectField
            darkMode={darkMode}
            endpoint={`/wholesaler/${formData?.id}/carriers/all`}
            fieldPath={FORM_FIELD_PATHS.CARRIERS}
            label="Carriers"
            placeholder="- Select Carriers -"
            tooltip="Select one or more carriers."
        />
    );
};

export default CarriersMultiSelect;
